import './styles.scss'

const stats = [
  { value: '28+', label: 'Years of Experience' },
  { value: '350+', label: 'Global Destinations' },
  { value: '10,000+', label: 'Shipments Delivered' },
  { value: '24/7', label: 'Customer Support' },
]

const StatsStrip = () => {
  return (
    <div className="stats-strip">
      {stats.map(({ value, label }) => (
        <div key={label} className="stats-strip__item">
          <span className="stats-strip__item__value">{value}</span>
          <span className="stats-strip__item__label">{label}</span>
        </div>
      ))}
    </div>
  )
}

export default StatsStrip
